import React from 'react';
function LayerArrowDown({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M17.0001 11.7229L21.5001 9.87795C21.654 9.79073 21.782 9.66425 21.8711 9.51141C21.9601 9.35857 22.0071 9.18484 22.0071 9.00795C22.0071 8.83106 21.9601 8.65733 21.8711 8.50449C21.782 8.35165 21.654 8.22517 21.5001 8.13795L13.0001 4.26795C12.6961 4.09241 12.3512 4 12.0001 4C11.649 4 11.3042 4.09241 11.0001 4.26795L2.50011 8.13795C2.34621 8.22517 2.21821 8.35165 2.12915 8.50449C2.04009 8.65733 1.99316 8.83106 1.99316 9.00795C1.99316 9.18484 2.04009 9.35857 2.12915 9.51141C2.21821 9.66425 2.34621 9.79073 2.50011 9.87795C2.50011 9.87795 5.5 11.0079 7.00011 11.7229M12.0001 9.00795V20.0079M12.0001 20.0079L17.0001 15.0079M12.0001 20.0079L7.00011 15.0079"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LayerArrowDown;
